
import React from 'react';
import { useHistory } from "react-router-dom";

import ToolbarCommandButton from '../../common/client/components/toolbar/ToolbarCommandButton';
import useAuthUser from '../../common/client/hooks/mysliveckyportal/useAuthUser';
import useAuthLoading from '../../common/client/hooks/mysliveckyportal/useAuthLoading';

const LoginInfo = () => {

    const user = useAuthUser();
    const loading = useAuthLoading();
    const history = useHistory();

    const handleEdit = () => {
        history.push('/editAccount');
    }

    const handleLogin = () => {
        history.push('/login');
    }

    const handleLogout = () => {
        history.push('/logout');
    }

    const handleChangePasword = () => {
        history.push('/changePassword');
    }

    const getItems = (user, loading) => {
        let items = [];
        if (user) {
            items.push({
                text: `${user.fullName} (${user.username})`,
                icon: 'UserOptional',
                items: [{
                    text: 'Aktualizovat účet',
                    disabled: (user.activated !== 1),
                    onClick: handleEdit
                }, {
                    text: 'Změnit heslo',
                    disabled: (user.activated !== 1),
                    onClick: handleChangePasword
                }, {
                    text: 'Odhlásit',
                    onClick: handleLogout
                }]
            });

        } else {
            if (!loading) {
                items.push({
                    text: 'Přihlásit',
                    icon: 'Permissions',
                    onClick: handleLogin
                });
            } else {
                items.push({
                    text: '...',
                    title: 'Načítám data...',
                    disabled: true,
                });
            }
        }
        return items;
    }

    const TEXT_COLOR = '#dddddd';

    return (
        <ToolbarCommandButton
            items={getItems(user, loading)}
            styles={{
                root: {
                    height: 25,
                },
                rootHovered: {
                    backgroundColor: '#777777'
                },
                label: {
                    color: TEXT_COLOR,
                },
                labelHovered: {
                    color: TEXT_COLOR
                },
                icon: {
                    color: TEXT_COLOR
                },
                iconHovered: {
                    color: TEXT_COLOR
                },
                iconPressed: {
                    color: TEXT_COLOR
                },
                menuIcon: {
                    color: TEXT_COLOR
                }
            }}
        />
    );
}

export default LoginInfo;
